<script>
import Title from "@/components/admin/common/TitleArea.vue"
import StatusBadge from "@/components/fulfillment/StatusBadge.vue"
import DataTable from "@/components/fulfillment/DataTable.vue"
import BrandForm from "@/components/admin/fulfillment/modal/BrandForm.vue"
import CategoryForm from "@/components/admin/fulfillment/modal/CategoryForm.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import FulfillmentPageGuide from "@/components/admin/fulfillment/guide/FulfillmentPageGuide.vue"

const TAB_BRAND = 'brand'
const TAB_CATEGORY = 'category'

export default {
  name: 'MasterDataManage',
  components: {
    Title,
    StatusBadge,
    DataTable,
    BrandForm,
    CategoryForm,
    PageGuideDialog,
    FulfillmentPageGuide
  },
  data() {
    return {
      description: {
        title: '브랜드/카테고리 관리'
      },
      activeTab: TAB_BRAND,
      tabs: [
        { label: '브랜드', value: TAB_BRAND },
        { label: '카테고리', value: TAB_CATEGORY },
      ],
      activeOptions: [
        { label: '전체', value: '' },
        { label: '활성', value: true },
        { label: '비활성', value: false },
      ],
      filtersByTab: {
        [TAB_BRAND]: { q: '', is_active: '' },
        [TAB_CATEGORY]: { q: '', is_active: '' },
      },
      rowsByTab: {
        [TAB_BRAND]: [],
        [TAB_CATEGORY]: [],
      },
      loadingByTab: {
        [TAB_BRAND]: false,
        [TAB_CATEGORY]: false,
      },
      pagination: { page: 1, rowsPerPage: 20 },
      brandDialog: false,
      categoryDialog: false,
      guideDialog: false,
      selectedBrand: {},
      selectedCategory: {},
    }
  },
  computed: {
    currentFilters() {
      return this.filtersByTab[this.activeTab]
    },
    currentRows() {
      return this.rowsByTab[this.activeTab]
    },
    currentLoading() {
      return this.loadingByTab[this.activeTab]
    },
    createButtonLabel() {
      return this.activeTab === TAB_BRAND ? '브랜드 등록' : '카테고리 등록'
    },
    searchLabel() {
      return this.activeTab === TAB_BRAND ? '브랜드명 검색' : '카테고리명 검색'
    },
    currentColumns() {
      if (this.activeTab === TAB_BRAND) {
        return [
          { name: 'brand_id', label: 'ID', field: 'brand_id', align: 'left' },
          { name: 'name', label: '브랜드명', field: 'name', align: 'left' },
          { name: 'is_active', label: '활성 여부', field: row => row.is_active ? 'ACTIVE' : 'INACTIVE', align: 'center' },
          { name: 'created_at', label: '생성일', field: row => this.formatDateTime(row.created_at), align: 'left' },
          { name: 'updated_at', label: '수정일', field: row => this.formatDateTime(row.updated_at), align: 'left' },
          { name: 'actions', label: '관리', field: 'actions', align: 'center' },
        ]
      }
      return [
        { name: 'category_id', label: 'ID', field: 'category_id', align: 'left' },
        { name: 'name', label: '카테고리명', field: 'name', align: 'left' },
        { name: 'default_spec_type', label: '기본 규격 타입', field: 'default_spec_type', align: 'center' },
        { name: 'is_active', label: '활성 여부', field: row => row.is_active ? 'ACTIVE' : 'INACTIVE', align: 'center' },
        { name: 'created_at', label: '생성일', field: row => this.formatDateTime(row.created_at), align: 'left' },
        { name: 'updated_at', label: '수정일', field: row => this.formatDateTime(row.updated_at), align: 'left' },
        { name: 'actions', label: '관리', field: 'actions', align: 'center' },
      ]
    },
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(value) {
        const tab = value === TAB_CATEGORY ? TAB_CATEGORY : TAB_BRAND
        this.activeTab = tab
      }
    },
    activeTab(next, prev) {
      if (next === prev) return
      this.syncRoute()
      if (!this.rowsByTab[next].length) {
        this.loadList(next)
      }
    }
  },
  methods: {
    syncRoute() {
      const nextTab = this.activeTab === TAB_CATEGORY ? TAB_CATEGORY : TAB_BRAND
      if (this.$route.query.tab === nextTab) return
      this.$router.replace({
        path: '/admin/fulfillment/master-data',
        query: { ...this.$route.query, tab: nextTab }
      })
    },
    buildQuery(tab) {
      const filters = this.filtersByTab[tab]
      return new URLSearchParams({
        q: filters.q || '',
        is_active: filters.is_active === '' ? '' : String(filters.is_active),
      }).toString()
    },
    async loadList(tab = this.activeTab) {
      this.loadingByTab[tab] = true
      const isBrand = tab === TAB_BRAND
      const config = {
        method: 'GET',
        url: isBrand
          ? `/api/fulfillment/admin/brands?${this.buildQuery(tab)}`
          : `/api/fulfillment/admin/categories?${this.buildQuery(tab)}`,
        name: isBrand ? '[ Fulfillment / 브랜드 관리 목록 ]' : '[ Fulfillment / 카테고리 관리 목록 ]'
      }
      await this.$http(config)
        .then((res) => {
          this.rowsByTab[tab] = Array.isArray(res.data?.data) ? res.data.data : []
        })
        .catch(() => {
          this.rowsByTab[tab] = []
        })
      this.loadingByTab[tab] = false
    },
    formatDateTime(value) {
      return value ? this.$formatDate(value, 'YYYY-MM-DD HH:mm:ss') : '-'
    },
    onSearch() {
      this.loadList(this.activeTab)
    },
    openCreate() {
      if (this.activeTab === TAB_BRAND) {
        this.selectedBrand = {}
        this.brandDialog = true
        return
      }
      this.selectedCategory = {}
      this.categoryDialog = true
    },
    openEdit(row) {
      if (this.activeTab === TAB_BRAND) {
        this.selectedBrand = { ...row }
        this.brandDialog = true
        return
      }
      this.selectedCategory = { ...row }
      this.categoryDialog = true
    },
    async saveBrand(payload) {
      const isEdit = !!payload?.brand_id
      const config = {
        method: isEdit ? 'PUT' : 'POST',
        url: isEdit ? `/api/fulfillment/admin/brands/${payload.brand_id}` : '/api/fulfillment/admin/brands',
        data: payload,
        name: '[ Fulfillment / 브랜드 저장 ]'
      }
      await this.$http(config)
        .then(() => {
          this.$q.notify({ type: 'positive', message: isEdit ? '브랜드가 수정되었습니다.' : '브랜드가 등록되었습니다.' })
          this.brandDialog = false
          this.loadList(TAB_BRAND)
        })
        .catch((e) => {
          this.$q.notify({ type: 'negative', message: e?.response?.data?.message || '브랜드 저장에 실패했습니다.' })
        })
    },
    async saveCategory(payload) {
      const isEdit = !!payload?.category_id
      const config = {
        method: isEdit ? 'PUT' : 'POST',
        url: isEdit ? `/api/fulfillment/admin/categories/${payload.category_id}` : '/api/fulfillment/admin/categories',
        data: payload,
        name: '[ Fulfillment / 카테고리 저장 ]'
      }
      await this.$http(config)
        .then(() => {
          this.$q.notify({ type: 'positive', message: isEdit ? '카테고리가 수정되었습니다.' : '카테고리가 등록되었습니다.' })
          this.categoryDialog = false
          this.loadList(TAB_CATEGORY)
        })
        .catch((e) => {
          this.$q.notify({ type: 'negative', message: e?.response?.data?.message || '카테고리 저장에 실패했습니다.' })
        })
    },
  },
  mounted() {
    this.loadList(this.activeTab)
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <template #title-action>
            <q-btn flat round dense size="sm" color="primary" icon="help_outline" aria-label="브랜드/카테고리 관리 사용 가이드" @click="guideDialog = true">
              <q-tooltip>브랜드/카테고리 관리 사용 가이드</q-tooltip>
            </q-btn>
          </template>
          <q-btn color="primary" icon="add" :label="createButtonLabel" @click="openCreate" />
        </Title>
      </div>
    </div>

    <div class="row q-mb-md">
      <div class="col">
        <div class="comp-box q-pa-md">
          <div class="text-body2 text-grey-7 q-mb-sm">
            상품 등록에 사용하는 브랜드와 카테고리 정보를 관리합니다.
          </div>
          <q-tabs
            v-model="activeTab"
            dense
            active-color="primary"
            indicator-color="primary"
            class="q-mb-md"
            align="left"
          >
            <q-tab
              v-for="tab in tabs"
              :key="tab.value"
              :name="tab.value"
              :label="tab.label"
            />
          </q-tabs>

          <div class="row q-col-gutter-md items-end">
            <div class="col-12 col-md-8">
              <q-input
                v-model="currentFilters.q"
                :label="searchLabel"
                dense
                outlined
                @keyup.enter="onSearch"
              />
            </div>
            <div class="col-12 col-md-2">
              <q-select
                v-model="currentFilters.is_active"
                :options="activeOptions"
                emit-value
                map-options
                label="활성 여부"
                dense
                outlined
              />
            </div>
            <div class="col-12 col-md-2">
              <q-btn color="primary" label="검색" class="full-width" @click="onSearch" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box">
          <DataTable
            :rows="currentRows"
            :columns="currentColumns"
            :row-key="activeTab === 'brand' ? 'brand_id' : 'category_id'"
            :loading="currentLoading"
            :pagination="pagination"
          >
            <template #body-cell-is_active="props">
              <q-td :props="props">
                <StatusBadge :status="props.value" />
              </q-td>
            </template>
            <template #body-cell-actions="props">
              <q-td :props="props">
                <q-btn flat dense color="primary" label="수정" @click="openEdit(props.row)" />
              </q-td>
            </template>
            <template #no-data>
              <div class="full-width column flex-center q-pa-xl text-grey-7">
                <q-icon name="category" size="36px" class="q-mb-sm" />
                <div class="text-body2">등록된 항목이 없습니다.</div>
                <div class="text-caption q-mt-xs">타이틀 영역의 등록 버튼을 눌러 새 항목을 추가하세요.</div>
              </div>
            </template>
          </DataTable>
        </div>
      </div>
    </div>

    <BrandForm
      v-model="brandDialog"
      :initial-data="selectedBrand"
      @submit="saveBrand"
    />
    <CategoryForm
      v-model="categoryDialog"
      :initial-data="selectedCategory"
      @submit="saveCategory"
    />
    <PageGuideDialog
      v-model="guideDialog"
      title="브랜드/카테고리 관리 사용 가이드"
      description="상품 등록에 사용하는 브랜드와 카테고리 정리 방법입니다."
    >
      <FulfillmentPageGuide guide-key="masterData" />
    </PageGuideDialog>
  </q-page>
</template>
